import {css} from 'lit'; export default css`.avatar-in-topbar{margin-right:-3px}.avatar-in-topbar::part(control){border-width:0}.avatar-in-topbar::part(control):focus{border-width:1px}:host chameleon-popover{--z-index:50010}`;
    